import { BookOpenIcon, DumbbellIcon, type LucideIcon } from 'lucide-react';

export interface Pillar {
  icon: LucideIcon;
  tag: string;
  title: string;
  value: string;
  today: string;
  lead: string;
  items: string[];
}

export const pillars: Pillar[] = [
  {
    icon: BookOpenIcon,
    tag: 'Incluido 📚',
    title: 'Los 6 Tomos del Sistema "Sesión en Mano"',
    value: '59,90€',
    today: 'Hoy: Incluido',
    lead: 'Sesiones profesionales listas para que nunca te falten ejercicios.',
    items: [
      'TOMO 1 — Metodología y Planificación "Cero Estrés": El cerebro de la temporada. Planificación anual, método 10-20-40-20 y cómo preparar sesiones profesionales en 5 minutos sin stress.',
      'TOMO 2 — Técnica Individual: Más de 60 ejercicios de dedos, antebrazo, saque y remate con fichas de corrección rápida. Cada página = 1 ejercicio listo.',
      'TOMO 3 — Táctica y Complejos (K1 y K2): 40 ejercicios de saque-recepción-ataque (K1) y bloqueo-defensa-contraataque (K2). Flujo real de partido.',
      'TOMO 4 — Preparación Física Integrada: Rutinas de salto, velocidad, agilidad y prevención de lesiones. Sin vueltas al campo. Con balón siempre. Ganancia de 10-15cm de salto en 3 meses.',
      'TOMO 5 — La Pizarra Maestra (Estrategia y Rotaciones): Más de 35 sistemas de juego, rotaciones, estrategia de saque y diagramas de ataque. Todo para ganar partidos.',
      'TOMO 6 — Gestión del Vestuario y Padres: El tomo que no enseñan en los cursos. Reunión de padres, jugador suplente, mentalidad bajo presión y marca personal del entrenador.'
    ]
  },
  {
    icon: DumbbellIcon,
    tag: 'Incluido 💪',
    title: 'Los 5 Bonos Estratégicos',
    value: '59,50€',
    today: 'Hoy: Incluido',
    lead: 'Los recursos que hacen que el sistema funcione desde el primer día.',
    items: [
      'Bono #1 — Plan de Arranque 7 Días: Por dónde empezar sin agobiarte entre 350 páginas. Diagnóstico, primera sesión, reunión con padres.',
      'Bono #2 — Sesión Express 15 Minutos: Para los días en que el tiempo no alcanza. Sesiones ultra-concentradas listas. Llega y ejecuta.',
      'Bono #3 — 30 Entrenamientos Listos para Pitar: Sesiones completas con tiempos exactos, ejercicios y correcciones. Un entrenamiento para cada día del mes.',
      'Bono #4 — 30 Juegos Técnicos para Base: Mejora dedos, antebrazo, coordinación con competición y motivación. Sin que parezca un ejercicio aburrido.',
      'Bono #5 — Mapa de Temporada en una Página: Toda la temporada (9 meses) planificada en una sola hoja imprimible. Cuelga en el vestuario. Todos saben dónde van.'
    ]
  }
];
